module.exports = __webpack_public_path__ + "media/insulation/Sprayfoam-0ea56b34.svg";